// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"QqOTmRF2","ButtonSkeleton":"LJSYW2jq","IconPlaceholder":"HTuMmum8"};